export default {"src":"/_next/static/media/logo.b75dea36.svg","height":27,"width":183,"blurWidth":0,"blurHeight":0};